import contactUsPhone from '../../Assets/images/contact_us_phone.png';
import contactUsMail from '../../Assets/images/contact_us_mail.png';

export const CONTACT_CARDS = [
  {
    id: 'phone',
    icon: contactUsPhone,
    iconAlt: 'Phone icon',
    label: 'DISPATCH HOTLINE:',
    value: '289-260-2582',
    action: 'Tap to call',
    href: 'tel:+12892602582',
  },
  {
    id: 'email',
    icon: contactUsMail,
    iconAlt: 'Email icon',
    label: 'TECHNICAL SUPPORT:',
    value: 'support@haulsync.ca',
    action: 'Tap to send email',
    href: 'mailto:support@haulsync.ca',
  },
];

export const HOURS_OF_OPERATION = [
  { id: 'weekday', day: 'Monday - Friday', hours: '6:00 AM - 6:00 PM EST', isClosed: false },
  { id: 'saturday', day: 'Saturday', hours: '7:00 AM - 2:00 PM EST', isClosed: false },
  { id: 'sunday', day: 'Sunday', hours: 'Closed', isClosed: true },
];

export const HOURS_NOTE =
  'For urgent after hours dispatch, call the hotline - we monitor 24/7 during peak season';

export const HEADQUARTERS = {
  name: 'HaulSync Inc.',
  lines: ['Toronto, Ontario, Canada'],
};

export const HERO_TEXT = {
  headingLine1: "Ready to Sync? Let's",
  headingLine2: 'Talk Shop.',
  description:
    'Whether you need a truck on-site or are looking to fill your schedule, our team is ready to assist.',
};

export const FORM_PLACEHOLDERS = {
  name: 'Name',
  email: 'Email',
  message: 'Message',
};

export const FORM_HINTS = {
  name: {
    idle: 'Please enter your full name',
    success: 'Name entered',
    required: 'Name is required',
    minLength: 'Name must be at least 2 characters',
    pattern: 'Name can only contain letters and spaces',
  },
  email: {
    idle: 'Please enter your email address',
    success: 'Email entered',
    required: 'Email is required',
    format: 'Please enter a valid email address',
  },
  message: {
    idle: 'Please describe how we can help you',
    success: 'Message entered',
    required: 'Message is required',
    maxLength: 'Message cannot exceed 255 characters',
  },
};

export const SUBMIT_LABEL = 'Send';
export const SUBMIT_LOADING_LABEL = 'Sending...';
export const SUBMIT_SUCCESS_TITLE = 'Message Sent!';
export const SUBMIT_SUCCESS_SUBTITLE =
  "Thank you for reaching out. We'll get back to you shortly.";
